import "./index.less"

import { getCountryApi_test, shopifyLogout, accountLogout } from '../../utils/fetch'
import HeaderSearch from '../header-search/index'
import { setContentWidth, resetContentWidth} from '../../utils/index'
import ResizeObserver from 'resize-observer-polyfill';
$(document).ready(function () { 
    if (!customElements.get('jky-header') && window?.pageInfo?.settings?.use_new_header) {
        customElements.define('jky-header', class JkyHeader extends HTMLElement {
          constructor() {
            super();
            this.selectors = {
              announce_close: $(this).find(".announce-bar .header-btn--close"),
              announce_bar: $(this).find(".announce-bar"),
              pictext: $(this).find(".menu-item-pictext"),
              pictext_tab: $(this).find(".menu-item-pictext .menu-item-pictext--tab-item"),
              pictext_content: $(this).find(".menu-item-pictext .menu-item-pictext--main-item"),
  
              menu_tab: $(this).find(".menu-item .menu-item--title"),
              menu_item: $(this).find(".menu-item .menu-item--content"),
              header: $(this).find("header"),
  
              modal: $(this).find(".modal-bg"),
  
              menu_item_close: $(this).find(".menu-close"),
  
              header_actions_item: $(this).find(".header-actions-item"),
  
              shop_menu_haschild: $(this).find(".trees-item.has--child"),
              shop_menu_nochild: $(this).find(".trees-item.no--child"),
            }
            this.active = {
              open: false,
              target: null
            }
            this.m_shoptab_scrolling = false

            const resizeObserver = new ResizeObserver((entries) => {
                const {height} = entries[0].contentRect;
                $('body').css('--jky-header-h', height + 'px')
              }
            );
            // 监听jky-header高度变化
            resizeObserver.observe(document.querySelector("jky-header"));

            this.init()
          }
  
          isMobile() {
            return window.matchMedia('(max-width: 1024px)').matches
          }

          isElementHorizontallyInViewport(element) { // 判断元素横向是否超出视口
            var rect = element.getBoundingClientRect();
            var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            return rect.right - viewportWidth;
          }
  
          initCssVars() { // 初始化设置css变量（动画使用）
            Array.from(this.selectors.menu_item).forEach(item => {
              $(item).css('--real-h', $(item.querySelector(".container")).innerHeight() + 'px')
  
              $(item).css('--item-total', $(item).find(".submenu-list-item").length)
              Array.from($(item).find(".submenu-list-item")).forEach(subitem => {
                $(subitem).css('--item-number', $(subitem).index() + 1)
              })
              // text--simple_sub-child
  
              Array.from($(item).find(".menu-item-text--simple_item")).forEach(subitem => {
                Array.from($(subitem).find(".text--simple_sub-child")).forEach(child => {
                  $(child).css('--item-number_text-simple', $(child).index() + 1)
                })
              })
  
              Array.from($(item).find(".sales-item")).forEach(subitem => {
                $(subitem).css('--item-number_sales', $(subitem).index() + 1)
              })
  
              Array.from($(item).find(".left-menu>.trees-item")).forEach(subitem => {
                $(subitem).css('--item-shop_menu-index', $(subitem).index() + 1)
              })
            })

            Array.from($(".menu-item .menu-item--title")).forEach((item, index) => { // GA postion
              $(item).attr("data-ga-params-position", index + 1)
            })

            Array.from($(".menu-list--mb .m-menu-item .title")).forEach((item, index) => { // GA postion
              $(item).attr("data-ga-params-position", index + 1)
            })
  
            $(this).find(".header-actions--user").css('--item-content-h', $(this).find(".header-user--content")
              .innerHeight() + 'px')

            Array.from($(".menu-list--mb>div")).forEach((item, index) => { // GA postion
              $(item).css('--delay-index', $(item).index() + 1)
            })

            let this_ = this
            !this.isMobile() && Array.from($(".menu-list .menu-item-text--simple")).forEach((item, index) => { // GA postion
              if(this_.isElementHorizontallyInViewport(item) > 0) {
                item.style.left = `${0 - this_.isElementHorizontallyInViewport(item) - 48}px`
              }
            })
          }
  
          toogleModal(flag = true) { // 背景遮罩控制
            if (flag) {
              this.selectors.modal.fadeIn(240)
            } else {
              this.selectors.modal.fadeOut(240)
            }
          }
  
          closeMenu() { // 导航菜单关闭 - 重置状态
            if (this.active.open) {
              this.selectors.menu_item.removeClass("no-animating")
              setTimeout(() => {
                this.selectors.menu_item.removeClass("open")
                this.selectors.menu_tab.removeClass("active")
                this.active.open = false
                $(this).removeClass("menu-active--open") 
                $(".shopify-section.jky-header").removeClass("menu-active--open")
                // 关闭遮罩背景
                this.toogleModal(false)
  
                $(this).find(".right-products").removeClass("loading-content")
              }, 0);

              resetContentWidth()
            }
          }
  
          openMenu(target_menu) { // 导航菜单开启 - 设置状态
            this.selectors.menu_tab.removeClass("active")
            this.selectors.menu_item.removeClass("open")
  
            target_menu.addClass("active")
            target_menu.siblings().addClass("open")
  
            if(target_menu.parent().hasClass("menu-item-shop")) {
              // shop menu
              const header_rect = $(this).find("header")[0].getBoundingClientRect()
              target_menu.parent().css('--shop-m-distance', header_rect.y + header_rect.height + 'px')
              target_menu.parent().find(".menu-item-shop--content").css('--real-h', `${window.innerHeight - header_rect.y - header_rect.height}px`)
  
              setTimeout(() => {
                $(this).find(".right-products").addClass("loading-content")
              }, 50);
            } else {
              $(this).find(".right-products").removeClass("loading-content")
            }
  
            setTimeout(() => {
              this.selectors.menu_item.addClass("no-animating")
            }, 240);
            this.active.open = true
            $(this).addClass("menu-active--open")
            $(".shopify-section.jky-header").addClass("menu-active--open")
            this.toogleModal(!target_menu.hasClass("menu-item--title--no-modal"))

            setContentWidth()
          }
  
          closeAnnouncebar() { // 通知栏关闭
            let that = this
            this.selectors.announce_close.click(function () {
              that.selectors.announce_bar.slideToggle(250)
            })
          }
  
          picTextMenuToggle() { // 图文菜单tab切换
            let that = this
            this.selectors.pictext_tab.click(function () { // 图文菜单tab切换
              if ($(this).hasClass("active")) return
              $(this).parent().find(".menu-item-pictext--tab-item").removeClass("active")
              $(this).parent().siblings().find(".menu-item-pictext--main-item").removeClass("active")
              $(this).addClass("active")
              $(this).parent().siblings().find(".menu-item-pictext--main-item").eq($(this).index()).addClass(
                "active")

              $(".menu-item-pictext--content").css('--real-h', $(document.querySelector(".menu-item-pictext--content").querySelector(".container .menu-item-pictext--main-item.active")).innerHeight() + 60 + 'px')
            })
          }
  
          userMenuOpen() { // 用户菜单展开
            $(this).find(".header-actions--user").addClass("open")
          }
  
          userMenuClose() { // 用户菜单关闭
            $(this).find(".header-actions--user").removeClass("open")
          }
  
          bindRightProductEvents(target) { // 产品区域交互事件bind
            // 设置product title超长class
            Array.from($(this).find(".header-product-gitem .p-title")).forEach(item => {
              const limit = this.isMobile() ? 40 : 40
              if ($(item).prop("scrollHeight") > 40) {
                $(item).parent().addClass("p-title--hover")
              }
            })

            Array.from($(this).find(".right-products .product-container .grid-product-list")).forEach(item => {
              if ($(item).find(".header-product-gitem").length <= 5) {
                $(item).addClass("grid-product-list--single")
              }
            })
            
            let _dom = target ? target : $(this)
            _dom.find(".right-products .product-container .product-show-all .btn").click(function () {
              if ($(this).hasClass("active")) { // 收起
                $(this).removeClass("active")
                $(this).parent().parent().find(".grid-product-list").removeClass("active")
              } else { // 展开所有
                $(this).addClass("active")
                $(this).parent().parent().find(".grid-product-list").addClass("active")
              }
            })
  
            Array.from($(this).find(".right-products .grid-product-list")).forEach((item, index) => {
              $(item).css('--grid-product-index', index + 1)
              $(item).css('--grid-product-total', Array.from($(item).find(".header-product-gitem")).length)
  
              Array.from($(item).find(".header-product-gitem")).forEach((subitem, i) => {
                $(subitem).css('--product-gitem-index', i + 1)
              })
            })
            
            try {
              $(this).find(".right-products").addClass("loading-content")
            } catch (error) {
              console.log(error)
            }

            // 重新绑定埋点采集事件
            setTimeout(() => {
              (function () {
                  const gaElts = target[0].querySelectorAll("[data-ga-event]");
                  if (gaElts.length === 0) return;
                  [...gaElts].map((elt) => {
                      try {
                          const evtType = elt.getAttribute("data-ga-action")
                          const evtName = elt.getAttribute("data-ga-event")
                          if (!evtType) return
                          if (!evtName) return
                          function handleGA (evt) {
                            const target = $(this)[0]
                            if(target.getAttribute("ga-loaded")) return
                            let url = '';
                            if (target.getAttribute("data-href")) {
                                // evt.preventDefault();
                                url = target.getAttribute("data-href");
                            }
                            let params = {}
                            const attributeNames = target.getAttributeNames();
    
                            attributeNames.forEach(attribute => {
                                if(attribute.indexOf("data-ga-params-") === 0) {
                                    const key = attribute.replace("data-ga-params-", "")
                                    params[key] = target.getAttribute(attribute)
                                }
                            });
                
                            try {
                              window.dataLayer.push({ event_parameters: null });
                              window.dataLayer.push({
                                  event: "ga4Event",
                                  event_name: evtName,
                                  event_parameters: {
                                      current_page: window.location.href,
                                      ...params
                                  }
                              });
                            } catch (error) {}
                            console.log("right-products ga", params)
    
                            setTimeout(function() {
                                if (url) {
                                    if(target.getAttribute("target") === "_blank") {
                                        window.open(url, "_blank");
                                    } else {
                                        window.location.href = url
                                    }
                                }
                            }, 40)
                          }
                          if(!elt.getAttribute("ga-loaded") && $(elt).is(".left-menu *")) {
                            elt.addEventListener(evtType, handleGA)
                            elt.setAttribute("ga-loaded", true)
                          }
                          if(!$(elt).is(".left-menu *") && !elt.getAttribute("ga-loaded")) {
                            elt.addEventListener(evtType, handleGA);
                          }
                      } catch (e) {
                          console.log(
                              "Something wrong happened when setting up event handling for ga4Events."
                          );
                      }
                  });
              })();
            }, 2000);
          }
  
          toggleShopTreeMenu() { // shop 菜单内部
            const that = this
            $(this).find(".trees-submenu").slideUp(0)
  
            this.selectors.shop_menu_haschild.click(function (event) { // 一级menu(has child) toogle
              if (!$(event.target).closest(".title-has--child").length) return
  
              if ($(this).hasClass("active")) { // close
                return
              } else { // Open
                $(that).find(".right-products").removeClass("loading-content")
  
                $(this).addClass("active")
                $(this).find(".trees-submenu").slideDown(240)
  
                // 复位其它menu
                $(this).parent().parent().find(".trees-submenu").not($(this).find(".trees-submenu")).slideUp(240)
                $(this).parent().parent().find(".trees-item.has--child").not($(this)).removeClass("active")
  
                // 更新产品区域 & 重新bind事件
                const clonedTemplate = $(this).find("template")[0].content.cloneNode(true)
                $(that).find(".right-products").scrollTop(0)

                // $(this).parent().parent().find(".right-products").off()
                $(this).parent().parent().find(".right-products").html(clonedTemplate)
                $(this).find(".trees-submenu .trees-item")[0] && $(this).find(".trees-submenu .trees-item")[0]
                  .click()
                
                // FIX: init status rebind events
                that.bindRightProductEvents($(event.target).closest(".menu-item-shop--content"))
              }
            })
  
            this.selectors.shop_menu_haschild.find(".trees-submenu .trees-item").click(
              function () { // 二级menu toogle

                if ($(this).hasClass("active")) return

                $(this).addClass("active")
    
                // 复位其它submenu
                $(this).closest(".left-menu").find(".trees-submenu .trees-item,.trees-item.no--child").not($(this)).removeClass(
                  "active")
    
                // 更新产品区域位置
                try {
                    $(that).find(".menu-item-shop--content.open .right-products")[0].scrollTo(0, $(that).find(`.right-products #${$(this).attr("target")}`)[0].offsetTop - $(that).find(".right-products .product-header-content").outerHeight() - 24)
                } catch (error) {
                  console.log(error)
                }
            })
  
            // 设置初始化状态
            $(this).find(".menu-item.menu-item-shop").each(function() {
              const default_menu = $(this)
              if (default_menu) {
                const first = $(default_menu).find(".trees-item.has--child")[0]
                if(!first) return
                if($(first).hasClass(".trees-item--submenu--noshow")) { // 只有二级菜单
                  $(first).trigger("click")
                } else { // 三级菜单
                  $(first).find(".title-has--child")[0] && $($(first).find(".title-has--child")[0]).trigger("click")
                }
                $(this).find(".right-products").removeClass("loading-content")
              }
            })
          }

          // mb: shop menu 三级菜单tab滚动联动
          fkScroll(_menu, index, bind = true) {
            if (!_menu || !this.tabs_swipers[`tabs_${index}`]) return
            const menu = _menu
            const _this = this


            const handleScroll = throttle(() => {
              if (this.m_shoptab_scrolling) return
              if (menu.find(".m-shop-submenu-tabs").length === 0) return
  
              const targetElements = menu.find(".toggle-content .m-shop-submenu-title")
              var cur_rect = $(_menu).find(".m-shop-submenu-tabs")[0].getBoundingClientRect()
              targetElements.each(function () {
                var target_rect = $(this)[0].getBoundingClientRect()
                if (cur_rect.bottom >= target_rect.top && cur_rect.bottom - target_rect.top <= $(this)
                  .outerHeight()) {
                  _this.tabs_swipers[`tabs_${index}`].slideTo(menu.find(
                      `.m-shop-submenu-tabs .swiper-slide[target=${$(this).attr("id")}]`).index(), 300,
                    false);
                  menu.find(".m-shop-submenu-tabs .swiper-slide").removeClass("active")
                  menu.find(`.m-shop-submenu-tabs .swiper-slide[target=${$(this).attr("id")}]`).addClass(
                    "active")
                }
              })
            }, 16)
            
            if (bind) {
              document.querySelector(".menu-list--mb").addEventListener("scroll", handleScroll)
            } else {
              document.querySelector(".menu-list--mb").removeEventListener("scroll", handleScroll)
            }
          }
  
          // 移动端事件
          mbToggleMenu() {
            let pic_scroll_flag = false
            const that = this

            // FIX: IPHONE 12下拉or上滚偶尔会重复绑定
            $(this).find(".header-toggle-btn--m").click(function () {
              if ($(this).hasClass("active")) { // close
                $(this).removeClass("active")
                $(that).find(".menu-list--mb").removeClass("open")
                $(".shopify-section.jky-header").removeClass("menu-active--open")
                resetContentWidth()

                setTimeout(() => {
                  $(this).attr("data-ga-params-module", "menu")
                }, 0);
              } else { // open
                const header_rect = $(that).find("header")[0].getBoundingClientRect()
                $(that).find("header").css('--mb-menu-h', `${window.innerHeight - header_rect.y - header_rect.height + 30}px`)
                // target_menu.parent().find(".menu-item-shop--content").css('--real-h', `${window.innerHeight - header_rect.y - header_rect.height}px`)

                $(this).addClass("active")
                $(that).find(".menu-list--mb").addClass("open")
                $(".shopify-section.jky-header").addClass("menu-active--open")
                setContentWidth()

                setTimeout(() => {
                  $(this).attr("data-ga-params-module", "close")
                }, 0);
              }
            })
  
            $(this).find(".menu-list--mb .m-menu-item").click(function (event) { // MB: shop menu toggle
              if (!$(event.target).closest(".title").length) return
  
              if ($(this).hasClass("active")) { // close
                $(this).removeClass("active")
                $(this).find(".content").slideUp(0)
              } else { // open
                $(this).addClass("active")
                $(this).find(".content").slideDown(0)
                $(that).find(".menu-list--mb .m-menu-item").not($(this)).removeClass("active")
                $(that).find(".menu-list--mb .m-menu-item .content").not($(this).find(".content")).slideUp(0)
                
                // FIX: low逼要模仿ecoflow
                setTimeout(() => {
                  try {
                    document.querySelector(".menu-list--mb").scrollTo(0, $(this)[0].offsetTop)
                  } catch (error) {
                    console.error(error)
                  }
                }, 20);
              }
            })
  
            $(this).find(".m-shop--content .m-shop-tree .m-shop-child").click(function (event) {
              if (!$(event.target).closest(".m-shop-child--title").length) return
              
              if ($(this).hasClass("active")) { // close
                $(this).removeClass("active")
                $(this).find(".toggle-content,.m-shop-submenu-tabs").slideUp(0)
                

                that.tabs_swipers[`tabs_${$(this).index()}`] && that.tabs_swipers[`tabs_${$(this).index()}`].slideTo(0)
              } else { // open
                $(this).addClass("active")
                $(this).find(".toggle-content, .m-shop-submenu-tabs").slideDown(0)
  
                // 关闭其它
                $(that).find(".m-shop--content .m-shop-tree .m-shop-child").not($(this)).removeClass("active")
                $(that).find(".m-shop--content .m-shop-tree .m-shop-child .toggle-content,.m-shop--content .m-shop-tree .m-shop-child .m-shop-submenu-tabs").not($(this).find(".toggle-content, .m-shop-submenu-tabs")).slideUp(0)

                // FIX: click collection scroll top
                setTimeout(() => {
                  try {
                    document.querySelector(".menu-list--mb").scrollTo(0, $(this)[0].offsetTop)
                  } catch (error) {
                    console.error(error)
                  }
                }, 20);

                // ADD CHILD TABS SCROLL ANIMAT
                try {
                  setTimeout(() => {
                    that.fkScroll($(this), $(this).index(), true)

                    $(that).find(".m-shop--content .m-shop-tree .m-shop-child").not($(this)).each(function() {
                      that.fkScroll($(this), $(this).index(), false)
                    })
                  }, 100);
                } catch (error) {
                  console.log(error)
                }
              }
            })
            
            let tabs_swipers = that.tabs_swipers = {}
            Array.from($(this).find(".m-shop-child")).forEach(sm => {
              const _index = $(sm).index()
              if ($(sm).find(".m-shop-submenu-tabs")[0]) {
                that.tabs_swipers[`tabs_${_index}`] = tabs_swipers[`tabs_${_index}`] = new Swiper($(sm).find(".m-shop-submenu-tabs")[0], {
                  slidesPerView: 'auto',
                  spaceBetween: 10,
                  freeMode: true,
                })
  
                Array.from($(sm).find(".m-shop-submenu-tabs")).forEach(item => {
                  $(item).find(".swiper-slide").click(function () {
                    if ($(this).hasClass("active")) return
  
                    $(item).find(".swiper-slide").removeClass("active")
                    $(this).addClass("active")
  
                    that.m_shoptab_scrolling = true
                    tabs_swipers[`tabs_${_index}`].slideTo($(this).index())
                    
                    setTimeout(() => {
                      that.m_shoptab_scrolling = false
                    }, 16);
                    try { // FIX: mb 三级分类滚动定位
                      const distance = $(that).find(".m-shop-submenu-tabs").outerHeight() + $(that).find(".m-shop-child--title").outerHeight()

                      $(that).find(".menu-list--mb")[0].scrollTo(0, $(that).find(`#${$(this).attr("target")}`)[0].offsetTop - distance)
                    } catch (error) {
                      console.log(error)
                    }
                  })
                })
              }
            })
  
            $(this).find(".m-shop-actions .m-shop-show-all").click(function () { // MB: SHOP submenu tabs
              if ($(this).hasClass("active")) { // close
                $(this).removeClass("active")
                $(this).parent().parent().parent().removeClass("show-all")
              } else { // open
                $(this).addClass("active")
                $(this).parent().parent().parent().addClass("show-all")
              }
            })
            
            if($(this).find(".m-pictext-tabs")[0]) {
              this.m_pictext_swiper = new Swiper($(this).find(".m-pictext-tabs")[0], {
                slidesPerView: 'auto',
                spaceBetween: 5,
                freeMode: true
              })
            }
  
            $(this).find(".m-pictext-tabs .swiper-slide").click(function(e) { // 图文tab点击
              if($(this).hasClass("active")) return
  
              $(that).find(".m-pictext-tabs .swiper-slide").removeClass("active")
              $(this).addClass("active")
              try {
                pic_scroll_flag = true
                const p_top = $(".m-menu-item--pictext.active")[0].offsetTop
                $(that).find(".menu-list--mb")[0].scrollTo(0, $(that).find(`#${$(this).attr("target")}`)[0].offsetTop + p_top - $(that).find(".m-menu-item--pictext .title").outerHeight())
                setTimeout(() => {
                  pic_scroll_flag = false
                }, 200);
              } catch (error) {
                console.log(error)
              }
            })

            function invertPicTab() {
              function didChangeViewport() {
                const doc = document.querySelector(".m-menu-item--pictext") || document
                const elements = Array.from(
                    doc.querySelectorAll(".m-pictext-list ul")
                );
                const isMobile = window.innerWidth < 1024;
    
                const slide = elements.find((element) => {
                    const MARGIN = isMobile ? 45.0 : 65.0;
                    const {
                        top,
                        bottom
                    } = element.getBoundingClientRect();
                    return top < MARGIN && bottom > MARGIN;
                });
                if (slide && !pic_scroll_flag) {
                  if (isMobile) {
                      $(that).find(".m-pictext-tabs .swiper-slide").removeClass("active")
                      $(that).find(".m-pictext-tabs .swiper-slide").eq($(slide).index()).addClass("active")
                      that.m_pictext_swiper.slideTo($(slide).index())
                  }
                } else {
                  return
                }
              }

              document.querySelector(".menu-list--mb").addEventListener("scroll", didChangeViewport, {
                passive: true
              });

              didChangeViewport();

              return function destroyInvertNavigation() {
                window.removeEventListener("scroll", didChangeViewport);
              };
            }

            invertPicTab()
          }
  
          // 开启搜索Modal
          handleSearch() {
              $(this).find(".header-actions--search").click(function () {
                  ZModle.getInstance(`<header-search class="search-modal__form search-modal__form__modal section-container" data-loading-text="Loading..." data-placeholder-text="${window.pageInfo.strings.headerStrings.searchPlaceholder}" data-class="header_p_search"></header-search>`, {
                    id: "header-local-zzl",
                    class: "header-search__private",
                    cb: (el) => {
                        el.querySelector("header-search").setAttribute("hd-open", new Date().getTime())
                    }
                  })
              })
          }

          // header 用户按钮操作
          handleUserAction() {
              const cookie = window.utils.cookie
              $(this).find(".header-user--register").click(function(e) {
                e.preventDefault();
                let uparams = {
                    register_act: "Account-Register"
                }
                setTimeout(() => {
                  window.location.href = `${e.target.href}&uparams=${encodeURIComponent(JSON.stringify(uparams))}`;
                }, 0);
              })

              $(this).find(".header-user-logout").click(function(e) {
                e.preventDefault();
                cookie.erase("_jk_user");
                cookie.erase("_jk_id");
                cookie.erase("_jk_quick_logined");
                cookie.erase("discount_code"); // 清除 优惠券码
                setTimeout(() => {
                    window.location.href = e.target.href;
                }, 0);
              })

              $(this).find(".header-user--pop-login").click(function() {
                  window.jackeryLoginApp && window.jackeryLoginApp.modalLogin({
                    "register_act": "Account-Register"
                  })
              })
          }

          // 国家切换
          handleGlobal() {
            const is_m = this.isMobile()
            $(this).find(".header-actions--global").click(function() {
                if ($(".header-actions--global").attr("data-loaded") === "loaded") {
                  ZModle.getInstance(null, {
                    header: window.pageInfo.strings.headerStrings.localTitle,
                    id: "header-xxx",
                    class: "header__changeLocal"
                  })
                  return
                }

                getCountryApi_test().then(res => {
                    $(".header-actions--global").attr("data-loaded", "loaded");
                    const current = res.data.current || {};
                    const isMobile = is_m; // 判断是否移动端
                    const list = res.data.lists || [];
              
                    const content = $(`<div class="local-content country-body"></div>`);
                    list.forEach((item) => {
                      const sublist = item.child || [];
                      const countrybox = $(`<div class="countrybox"><p class="countrybox--title">${item.continent}</p></div>`);
                      const countrylist = $(`<ul class="countrylist"></ul>`);
                      sublist.forEach((i) => {
                        const activeCountry = current.official_country === i.official_country;
                        const isShowCartIcon = i.saleShow === 1; // 获取当前子项的 is_show 值
                        const cartIconHTML = isShowCartIcon
                          ? `<i class="jky-fa-shopping-cart" style="background: url('${isMobile ? 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/car-icon-mb.svg?v=1700637746' : 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/car-icon-pc.svg?v=1700637743'}')center center / cover no-repeat;"></i>`
                          : '';
                        countrylist.append(`
                          <a href="${i.domain}" class="countrylist--item ga-data ${activeCountry ? 'active' : ''}">
                            <li>
                              <span class="countrylist--desc">${i.official_country}</span>
                              ${cartIconHTML}
                              <span class="countrylist--lang">${i.official_language}</span>
                            </li>
                          </a>
                        `);
                      });
                      countrybox.append(countrylist);
                      content.append(countrybox);
                    });
                    ZModle.getInstance(content[0], {
                      header: window.pageInfo.strings.headerStrings.localTitle,
                      id: "header-xxx",
                      class: "header__changeLocal"
                    });
                });
            })
          }
  
          init() {
            const isMobile = this.isMobile()
            const that = this
  
            this.initCssVars()
            this.closeAnnouncebar() 
            this.handleUserAction()
            this.handleGlobal()
            this.handleSearch()

            !isMobile && this.picTextMenuToggle() 
            !isMobile && this.toggleShopTreeMenu()
            isMobile && this.mbToggleMenu()
  
            !isMobile && this.selectors.menu_tab.mouseover(function () { // toggle menu
              if ($(this).hasClass("active")) return
              that.userMenuClose()
              that.openMenu($(this))
            })
  
            !isMobile && this.selectors.header.mouseleave(function () { // 鼠标移出header区域关闭menu
              that.closeMenu()
            })
  
            !isMobile && this.selectors.menu_item_close.click(() => this.closeMenu())
  
            // 用户菜单
            !isMobile && this.selectors.header_actions_item.mouseover(() => this.closeMenu())
            if(!isMobile) {
              $(this).find(".header-actions--user").on('mouseenter', function (event) {
                event.stopPropagation();
                that.userMenuOpen()
              })

              $(this).find(".header-actions--user").on('mouseleave', function (event) {
                event.stopPropagation();
                that.userMenuClose()
              })
            } else {
              $(this).find(".header-actions--user").on('touchstart', function (event) {
                if (!$(this).hasClass("open")) {
                  that.userMenuOpen()
                }
              })
            }
  
            $(document).click(function (event) {
              const target = $(event.target);
  
              //  PC：点击usermenu外部关闭menu
              if (!target.closest($(that).find(".header-actions--user")).length || target.hasClass("header-user--menu-bg")) {
                that.userMenuClose()
              }
            });
          }
        })
    }

    customElements.define('header-search', HeaderSearch);
 })
